import { PayloadAction } from '@reduxjs/toolkit';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateSearch } from './state_search';

export const local_search_upsert = (payload: DTOSearchSettings[]): PayloadAction<DTOSearchSettings[]> => ({
  type: ENUM__redux_action.SEARCH_UPSERT,
  payload: payload,
});

export const init_local_search_upsert = (state: StateSearch, action: PayloadAction<DTOSearchSettings[]>) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    if (state.search_current._id == item._id) {
      state.search_current = item;
    }

    state.search_history_map.set(item._id, item);
  }

  //refresh map to trigger re-render
  state.search_history_map = new Map(state.search_history_map);
};
